import type { AppContext } from "@/types/scheduling";
import type { WritableDraft } from "immer";

import { produce } from "immer";

export const handleAllowNext = <T extends AppContext>(context: T, params: { key: string }) => {
  return produce(context, (draft: WritableDraft<AppContext>) => {
    if (params.key === 'insurance_provider_other') {
      draft.next_allowed.insurance_selection_other = true;
    }
    if (params.key === 'lead_name') {
      draft.next_allowed.lead_name = true;
    }
    if (params.key === 'lead_email') {
      draft.next_allowed.lead_email = true;
    }
    if (params.key === 'lead_phone_number') {
      draft.next_allowed.lead_phone_number = true;
    }
  })
}
